import React, { useEffect } from "react";

import { RouterProvider } from "react-router-dom";
import { useLoading } from "./../shared/services/providers/loading.context";
import { routes } from "../routes/routes";
import AuthProvider from "../shared/services/providers/auth.provider";
import { setupInterceptors } from "../shared/services/axios.instance";
import LoadingSpinner from "../shared/components/LoadingSpinner";

function CustomMain() {
  const { setIsLoading } = useLoading();

  useEffect(() => {
    setupInterceptors(setIsLoading); // Setup interceptors with loading state
  }, [setIsLoading]);
  return (
    <React.Fragment>
      <LoadingSpinner />
      <AuthProvider>
        <RouterProvider router={routes}></RouterProvider>
      </AuthProvider>
    </React.Fragment>
  );
}

export default CustomMain;
